 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import A781783784370_COVER from '@/components/9781783784370_cover'
 import LOVE_1 from '@/components/love_1'
 import A781783784370_PRAISE from '@/components/9781783784370_praise'
 import A781783784370_BOOKTITLEPAGE from '@/components/9781783784370_booktitlepage'
 import A781783784370_DEDICATION from '@/components/9781783784370_dedication'
 import A781783784370_TABLEOFCONTENTS from '@/components/9781783784370_tableofcontents'
 import A781783784370_LISTOFILLUSTRATIONS from '@/components/9781783784370_listofillustrations'
 import A781783784370_OTHER_01 from '@/components/9781783784370_other_01'
 import A781783784370_OTHER_02 from '@/components/9781783784370_other_02'
 import A781783784370_PROLOGUE from '@/components/9781783784370_prologue'
 import A781783784370_CHAPTER_01 from '@/components/9781783784370_chapter_01'
 import A781783784370_CHAPTER_02 from '@/components/9781783784370_chapter_02'
 import A781783784370_CHAPTER_03 from '@/components/9781783784370_chapter_03'
 import A781783784370_CHAPTER_04 from '@/components/9781783784370_chapter_04'
 import A781783784370_CHAPTER_05 from '@/components/9781783784370_chapter_05'
 import A781783784370_CHAPTER_06 from '@/components/9781783784370_chapter_06'
 import A781783784370_CHAPTER_07 from '@/components/9781783784370_chapter_07'
 import A781783784370_CHAPTER_08 from '@/components/9781783784370_chapter_08'
 import A781783784370_CHAPTER_09 from '@/components/9781783784370_chapter_09'
 import A781783784370_CHAPTER_10 from '@/components/9781783784370_chapter_10'
 import A781783784370_CHAPTER_11 from '@/components/9781783784370_chapter_11'
 import A781783784370_CHAPTER_12 from '@/components/9781783784370_chapter_12'
 import A781783784370_CHAPTER_13 from '@/components/9781783784370_chapter_13'
 import A781783784370_CHAPTER_14 from '@/components/9781783784370_chapter_14'
 import A781783784370_CHAPTER_15 from '@/components/9781783784370_chapter_15'
 import A781783784370_CHAPTER_16 from '@/components/9781783784370_chapter_16'
 import A781783784370_CHAPTER_17 from '@/components/9781783784370_chapter_17'
 import A781783784370_CHAPTER_18 from '@/components/9781783784370_chapter_18'
 import A781783784370_CHAPTER_19 from '@/components/9781783784370_chapter_19'
 import A781783784370_CHAPTER_20 from '@/components/9781783784370_chapter_20'
 import A781783784370_CHAPTER_21 from '@/components/9781783784370_chapter_21'
 import A781783784370_CHAPTER_22 from '@/components/9781783784370_chapter_22'
 import A781783784370_CHAPTER_23 from '@/components/9781783784370_chapter_23'
 import A781783784370_CHAPTER_24 from '@/components/9781783784370_chapter_24'
 import A781783784370_BIBLIOGRAPHY from '@/components/9781783784370_bibliography'
 import A781783784370_ACKNOWLEDGEMENTS from '@/components/9781783784370_acknowledgements'
 import A781783784370_OTHER_03 from '@/components/9781783784370_other_03'
 import A781783784370_OTHER_04 from '@/components/9781783784370_other_04'
 import A781783784370_INDEX_01_A from '@/components/9781783784370_index_01_a'
 import A781783784370_INDEX_01_B from '@/components/9781783784370_index_01_b'
 import A781783784370_INDEX_01_C from '@/components/9781783784370_index_01_c'
 import A781783784370_INDEX_01_D from '@/components/9781783784370_index_01_d'
 import A781783784370_INDEX_01_E from '@/components/9781783784370_index_01_e'
 import A781783784370_INDEX_01_F from '@/components/9781783784370_index_01_f'
 import A781783784370_INDEX_01_G from '@/components/9781783784370_index_01_g'
 import A781783784370_INDEX_01_H from '@/components/9781783784370_index_01_h'
 import A781783784370_INDEX_01_I from '@/components/9781783784370_index_01_i'
 import A781783784370_INDEX_01_J from '@/components/9781783784370_index_01_j'
 import A781783784370_INDEX_01_K from '@/components/9781783784370_index_01_k'
 import A781783784370_INDEX_01_L from '@/components/9781783784370_index_01_l'
 import A781783784370_INDEX_01_M from '@/components/9781783784370_index_01_m'
 import A781783784370_INDEX_01_N from '@/components/9781783784370_index_01_n'
 import A781783784370_INDEX_01_O from '@/components/9781783784370_index_01_o'
 import A781783784370_INDEX_01_P from '@/components/9781783784370_index_01_p'
 import A781783784370_INDEX_01_Q from '@/components/9781783784370_index_01_q'
 import A781783784370_INDEX_01_R from '@/components/9781783784370_index_01_r'
 import A781783784370_INDEX_01_S from '@/components/9781783784370_index_01_s'
 import A781783784370_INDEX_01_T from '@/components/9781783784370_index_01_t'
 import A781783784370_INDEX_01_U from '@/components/9781783784370_index_01_u'
 import A781783784370_INDEX_01_V from '@/components/9781783784370_index_01_v'
 import A781783784370_INDEX_01_W from '@/components/9781783784370_index_01_w'
 import A781783784370_INDEX_01_Y from '@/components/9781783784370_index_01_y'
 import A781783784370_INDEX_01_Z from '@/components/9781783784370_index_01_z'
 import A781783784370_PLATEPAGE from '@/components/9781783784370_platepage'
 import LOVE_2 from '@/components/love_2'
 import A781783784370_COPYRIGHTINSERTED from '@/components/9781783784370_copyrightinserted'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/9781783784370_tableofcontents",
 			"name" : "9781783784370_tableofcontents",
 			"component" : A781783784370_TABLEOFCONTENTS
 		},
 		{
 			"path" : "/9781783784370_listofillustrations",
 			"name" : "9781783784370_listofillustrations",
 			"component" : A781783784370_LISTOFILLUSTRATIONS
 		},
 		{
 			"path" : "/9781783784370_other_01",
 			"name" : "9781783784370_other_01",
 			"component" : A781783784370_OTHER_01
 		},
 		{
 			"path" : "/9781783784370_other_02",
 			"name" : "9781783784370_other_02",
 			"component" : A781783784370_OTHER_02
 		},
 		{
 			"path" : "/9781783784370_prologue",
 			"name" : "9781783784370_prologue",
 			"component" : A781783784370_PROLOGUE
 		},
 		{
 			"path" : "/9781783784370_chapter_01",
 			"name" : "9781783784370_chapter_01",
 			"component" : A781783784370_CHAPTER_01
 		},
 		{
 			"path" : "/9781783784370_chapter_02",
 			"name" : "9781783784370_chapter_02",
 			"component" : A781783784370_CHAPTER_02
 		},
 		{
 			"path" : "/9781783784370_chapter_03",
 			"name" : "9781783784370_chapter_03",
 			"component" : A781783784370_CHAPTER_03
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js